"use client";

import { useContext } from "react";

import { useTranslation } from "~/app/hooks/useTranslation";

import FAQCollapse from "./FAQCollapse";
import FaqSchema from "./FaqSchema";
import { HelpCenterContext } from "../context";
import { filterFaqs } from "../search";

import styles from "../[slug]/page.module.scss";

export default function FaqResults({ slug, locale }) {
  const { t } = useTranslation();
  const ctx = useContext(HelpCenterContext);
  const filteredFaqs = filterFaqs(ctx.faqContent[slug], ctx.searchState.value, locale);
  if (!filteredFaqs || filteredFaqs.length === 0) {
    return (
      <section className={styles.noFAQsContainer} role="status">
        <h2>{t("helpCenter.noFAQs")}</h2>
      </section>
    );
  }
  return (
    <section className={styles.container}>
      <FaqSchema items={filteredFaqs}/>
      {filteredFaqs?.map((faq) => (
        <FAQCollapse key={faq.question} title={faq.question}>
          <div className={styles.faqContent}>{faq.answer}</div>
        </FAQCollapse>
      ))}
    </section>
  );
}
